import * as React from 'react';
import { cn } from '@/lib/utils';

const FormText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-form-text',
      // styles
      'mb-0 block text-xs text-neutral',
      className
    )}
    {...props}
  />
));
FormText.displayName = 'FormText';

export { FormText };
